import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useHttp } from '../../hooks/http.hook'
import { Roles } from '../../hooks/auth.hook'
import { AuthContext } from '../../context/AuthContext'
//import { LanguagesContext } from '../../context/LanguagesContext'
import { Form } from 'react-bootstrap'; // , Dropdown, DropdownButton
import { Toaster } from '../components/Toaster'

export const PermissionBlock = ({ clientData }) => { //setReceivedError

    const { request, loading, error } = useHttp()
    const [receivedError, setReceivedError] = useState(error)
    const { token } = useContext(AuthContext)
    //const { activeLanguage } = useContext(LanguagesContext); //pageLanguage

    const [users, setUsers] = useState([])

    const [userForm, setUserForm] = useState({})
    const [userUpdateForm, setUserUpdateForm] = useState([])

    const rolesDropdownList = [Roles.Moderator, Roles.Officer, Roles.Analytic]

    const fetchSuperUsers = useCallback(async () => {
        let path = `/user/client/${clientData.id}`

        try {
            const fetched = await request(path, 'GET', null, {
                'x-access-token': token
            })
            if (fetched.users) {
                //console.log(fetched.users);
                setUsers(fetched.users)
            }

        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, clientData.id, setReceivedError])

    useEffect(() => {
        fetchSuperUsers()
    }, [fetchSuperUsers])


    const changeUserForm = event => {
        setUserForm({ ...userForm, [event.target.name]: event.target.value })
        //console.log('new user form', userForm);
    }

    const updateUserHandler = (user, key, val) => {

        if (userUpdateForm.some(item => item.id === user.id)) {
            //console.log("Object found inside the array.");
            setUserUpdateForm(
                userUpdateForm => userUpdateForm.map(
                    u => {
                        if (u.id === user.id) {
                            u[key] = val
                        }
                        return u
                    }
                )
            )
        } else {
            //console.log("?Object not found."); // so adding new
            user[key] = val;
            setUserUpdateForm([...userUpdateForm, user])
        }
    }


    const addUser = async () => {
        try {  // add super user with delault analytic role
            const userData = await request('/user/add', 'POST', { client_id: clientData.id, requestedRole: Roles.Analytic, users: [userForm] }, {
                'x-access-token': token
            })

            if (userData) {
                setUsers(users => [...users, ...userData])
                //  setUserForm({ client_id: clientData.id })  // hide because form is uncontrolled
            }

        } catch (e) {
            setReceivedError(e.message)
        }
    }

    const deleteUser = async (val) => {
        try {
            const data = await request(`/user/remove/${val}`, 'GET', null, {
                'x-access-token': token
            })
            if (data.changed === 1) {
                setUsers(users => users.filter(item => item.id !== val))
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeUser = async (user_id) => {
        let data_form = userUpdateForm.filter(item => {
            return item.id === user_id
        })
        try {
            const data = await request(`/user/update/${user_id}`, 'POST', data_form[0], {
                'x-access-token': token
            })

            if (data.changed === 1) {
                setUsers(
                    users => users.map(
                        item => {
                            if (item.id === user_id) {
                                //item.name = data_form[0].name
                                item.email = data_form[0].email
                            }
                            return item;
                        }
                    )
                )
            }
            setUserUpdateForm(user => user.filter(item => item.id !== user_id))
        } catch (e) {
            setReceivedError(e)
        }
    }


    /*  very old user activation code
       const userActivationChange = async (active, id) => {
           console.log('user active', active);
           console.log('user active opposite', !active);
           const new_activation = !active
           try {
               const data = await request(`/user/update_activation/${id}`, 'POST', { active: new_activation }, {
                   'x-access-token': token
               })
               
               if (data.changed === 1) {
                   setUsers(
                       users => users.map(
                           item => {
                               if (item.id === id)
                                   item.active = !active
                               return item;
                           }
                       )
                   )
               }
           } catch (e) {
               setReceivedError(e)
           }
   
       }
   */

    return (
        <div>
            <h3 className="mt-5 FormTitle">Permissions</h3>
            <form className="FormBlock pb-3" autoComplete="off">
                <div className="mt-1 mb-2 FormBlockElement" >
                    <input autoComplete="new-off" type="email" placeholder="Enter Email.." name="email" onChange={changeUserForm} className="FormInputSmall mr-2" />
                    {/*
                    <input autoComplete="new-off" type="password" placeholder="Enter new password.." name="password" onChange={changeUserForm} className="FormInputSmall mr-2" />
                   */}
                    <button type="submit" className="ButtonBlockSmall mt-0" disabled={loading} onClick={addUser}>
                        Add
                    </button>
                </div>
            </form>
            {(receivedError) ? <Toaster errors_list={receivedError} error_state={setReceivedError} /> : ''}
            <table className="Table" bordered="0px" size="sm">
                <thead>
                    <tr className="px-5">
                        <th key="email" className="TableFirstLineBlock">Email</th>
                        <th key="role" className="TableFirstLineBlock">Role</th>
                        <th key="action" className="TableFirstLineBlock">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {(users && users.length)
                        ? users.map((user, index) => (
                            <tr className="TableBlock" key={user.id}>
                                <td className="TableSecondLineBlock CenterContent FormText"
                                    onKeyPress={(e => {
                                        if (e.which === 13 || e.keyCode === 13) {
                                            e.preventDefault();
                                        }
                                    })}
                                    onInput={(e) => {
                                        const val = e.currentTarget.textContent;
                                        let data = user;
                                        updateUserHandler(data, 'email', val);
                                        updateUserHandler(data, 'updated', 1);
                                    }} contentEditable="true">
                                    {user.email}
                                </td>
                                <td className="TableSecondLineBlock">
                                    <Form.Control className="BoxShadow" as="select" custom
                                        onChange={(e) => {
                                            let select = e.target.value;
                                            let data = user;
                                            updateUserHandler(data, 'role', select);
                                            updateUserHandler(data, 'updated', 1);
                                        }}
                                        style={{
                                            minWidth: '75px',
                                            fontWeight: '200',
                                            fontSize: '22px'
                                        }}
                                        defaultValue={user.role}>
                                        <option className="FormTextDark" disabled> -- select an option --</option>
                                        {rolesDropdownList.map((role, index) => (
                                            <option key={index} className="FormTextDark">{role}</option>
                                        ))}
                                    </Form.Control>
                                </td>
                                <td className="TableSecondLineBlock">
                                    {userUpdateForm.some(userUpdateForm => userUpdateForm.id === user.id && userUpdateForm.updated === 1)
                                        && <img src="/img/save_white.png" alt="" onClick={() => changeUser(user.id)} className="CardBlockHederImgSmall mx-3" />}
                                    <img src="/img/TrashB.png" alt="" onClick={() => {
                                        if (window.confirm('Delete this item?')) {
                                            deleteUser(user.id);
                                        }
                                    }} className="CardBlockHederImgSmall mx-1" />
                                </td>
                            </tr>
                        ))
                        : <tr>
                            <td colSpan={3} className='text-white text-center'>No company users have been added</td>
                        </tr>}
                </tbody>
            </table>
        </div>
    );
};
